<template>
    <div class="container-fluid my-1">
        <div v-if="$_store.state.typeEventMaterial.type === 'E'">
            <div class="ps-2 pe-2 mb-3" >
                <label for="name" class="form-label">Nome do Material</label>
                <input
                    v-model="material"
                    type="text"
                    class="form-control"
                    id="name"
                    required
                    :placeholder="$_store.state.typeEventMaterial.nameMaterial"
                />
                <p class="p-error-label">{{ errorLabel?.material || errorLabel?.error }}</p>
            </div>

            <div class="d-flex justify-content-center mb-2">
                <button 
                    class="btn btn-dark me-1 col-6" 
                    @click="sendEditMaterial"
                    :disabled="!material ? true : false"
                >
                Confirmar
                </button>
                <button 
                    id="closeButtonEdit"
                    class="btn btn-outline-danger ms-1 col-6" 
                    data-bs-dismiss="modal" 
                    aria-label="Close">
                    Cancelar
                </button>
            </div> 
        </div>
        <div v-else>
            <div class="d-flex justify-content-center mb-2">
                <button 
                    class="btn btn-dark me-1 col-6"
                    @click="sendDeleteMaterial"
                >
                Confirmar
                </button>
                <button 
                    id="closeButton" 
                    class="btn btn-outline-danger ms-1 col-6" 
                    data-bs-dismiss="modal" 
                    aria-label="Close">
                    Cancelar
                </button>
            </div> 
        </div> 
    </div>
</template>

<script>
import { ref } from 'vue';
import store from "../../store";
import { editMaterial, deleteMaterial } from "../../http"
import { sendEventMaterial } from "../../socket";

export default {
setup() {

  const  material = ref('');
  const errorLabel = ref({
    material: null,
    error: null
  })

  const sendEditMaterial = async () => {
    if(material.value){
        const payload = {id: store.state.typeEventMaterial.material, name: material.value};
        await editMaterial(store.state.typeEventMaterial.material, payload)
            .then((data)=>{
            if(!data?.status){
                errorLabel.value.error = data?.message;
                return;
            }
            
            store.dispatch('setMaterialList', payload);
            sendEventMaterial('graphic', payload);
            material.value = '';
            document.getElementById("closeButtonEdit").click();

            });
    }else{
        errorLabel.value.material = "Campo obrigatório.";
    }
  }

  const sendDeleteMaterial = async () => {
    await deleteMaterial(store.state.typeEventMaterial.material)
        .then(() => {
            const data = {id: store.state.typeEventMaterial.material, delete: true};
            store.dispatch('setMaterialList', data);
            sendEventMaterial('graphic', data);
            document.getElementById("closeButton").click();
    });

  }

  return {
      material,
      sendEditMaterial,
      sendDeleteMaterial
  };
}
};
</script>

<style>
.p-error-label {
  font-size: 14px;
  color: red;
}
</style>
